import React from "react"
import {  withPrefix } from "gatsby"

import Layout from "../components/Layout"
import SEO from "../components/SEO"
import PageSection from "../components/PageSection"


const ResearchPage = () => (
  <Layout>
    <SEO title="Research" />
    <h1>Research</h1>

    <PageSection title="Research Interests" id="ResearchInterests">
      <p><strong>Keywords:</strong> Human-computer interaction; human behavior in video games and other virtual environments; computational models of cognition.</p>

    </PageSection>

    <PageSection title="Publications" id="Publications">
      <pub-viewer src={withPrefix("/publications.json")} current-author="ignacioxd" show-book="false" heading-tag="h3" base-pdf-url={withPrefix(`/files/bib/`)}></pub-viewer>
    </PageSection>

    <PageSection title="Citing My Name" id="CitingMyName">
      <p>Formally, my last name has an accent mark. While I'm not picky about its use in informal communications, I do prefer it on formal settings such as publications.
    Since not every keyboard layout makes it easy to type particular characters, I'm providing this for convenience in case you happen to have the need to cite my name.</p>
      <p>If you are using LaTeX, please use the following form:</p>
      <pre>Ignacio X. Dom\'inguez</pre>
      <p>On Web pages or XML documents, you can use HTML entities:</p>
      <pre>Ignacio X. Dom&amp;iacute;nguez</pre>
      <p>or</p>
      <pre>Ignacio X. Dom&amp;#237;nguez</pre>
      <p>In other situations, simply copying and pasting the following should work:</p>
      <pre>Ignacio X. Domínguez</pre>
    </PageSection>



  </Layout>
)

export default ResearchPage
